import React from 'react';
import { navigate } from 'gatsby';
import gitDoneLogo from '../../../images/gitdone.png'

const handleClick = () => {
  navigate('/');
};

const Logo = () => (
  <img src={gitDoneLogo} alt="Rocketseat logo" style={{ width: 180 }} onClick={handleClick}/>
);

export default Logo;